export const HOME_NAV_DESKTOP_MIN_WIDTH = 1201;
export const HOME_SOLUTION_SHOWCASE_PIN_MIN_WIDTH = 0;

export const HOME_NAV_DESKTOP_MEDIA_QUERY = `(min-width: ${String(HOME_NAV_DESKTOP_MIN_WIDTH)}px)`;
export const HOME_SOLUTION_SHOWCASE_PIN_MEDIA_QUERY = `(min-width: ${String(HOME_SOLUTION_SHOWCASE_PIN_MIN_WIDTH)}px)`;
